import { createRootRoute, Outlet, HeadContent, Scripts } from '@tanstack/react-router'
import Header from "@/components/layout/Header"
import Footer from "@/components/layout/Footer"
import appCss from '@/globals.css?url'

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
      { title: 'EVTCC' },
      { name: 'msvalidate.01', content: '6DD2EA3A18AFF067519EBE7A17493F26' },
    ],
    links: [
      { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
      { rel: 'stylesheet', href: appCss },
    ],
  }),
  component: RootComponent,
})

function RootComponent() {
  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body>
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="w-full grow">
            <Outlet />
          </main>
          <Footer />
        </div>
        <Scripts />
      </body>
    </html>
  )
}
